import styled from 'styled-components';

import { Button } from '@xingternal/button';
import { zIndexAboveContent } from '@xingternal/layout-tokens';
import { spaceS } from '@xingternal/tokens';

// This button appears on top of the Logo, when on Focus.
// Make sure to keep it behind/above Header's z-index
const SkipNavigationButton = styled(Button)`
  left: ${spaceS};
  opacity: 0;
  position: fixed;
  top: ${spaceS};
  transition: opacity 150ms cubic-bezier(0.2, 0.2, 0.2, 1); /* former ODL --transition */
  z-index: -${zIndexAboveContent};

  &:focus {
    opacity: 1;
    z-index: ${zIndexAboveContent};
  }
`;

export { SkipNavigationButton };
